import type * as Blockly from 'blockly/core';
import { expr, registerHelperFunction } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

const STDDEV_CALC_HELPER_CODE = [
    'float _sbeGetStddev(float sample, float* buf, int* count, int* idx, int n) {',
    '  buf[*idx] = sample;',
    '  *idx = (*idx + 1) % n;',
    '  if (*count < n) (*count)++;',
    '  float sum = 0.0;',
    '  for (int i = 0; i < *count; i++) {',
    '    sum += buf[i];',
    '  }',
    '  float mean = sum / *count;',
    '  float variance = 0.0;',
    '  for (int i = 0; i < *count; i++) {',
    '    float diff = buf[i] - mean;',
    '    variance += diff * diff;',
    '  }',
    '  variance /= *count;',
    '  return sqrt(variance);',
    '}',
].join('\n') + '\n';

function stddevStateCode(bufName: string, countName: string, idxName: string, n: number): string {
    return `float ${bufName}[${n}];\nint ${countName} = 0;\nint ${idxName} = 0;\n`;
}

export function register(gen: any): void {
    gen.forBlock['math_stddev'] = function (block: Blockly.Block): [string, number] {
        const n = Math.round(Number(block.getFieldValue('N')));
        const value = gen.valueToCode(block, 'VALUE', 0) || '0';
        // BlocklyのIDは記号(-、_等)を含むため、英数字以外を一律'_'にすると別IDが同じ識別子になり、
        // 2つのブロックが状態変数(配列サイズの異なるバッファ)を共有してしまう。英数字以外は
        // '_'+文字コード(16進2桁)に置き換え、異なるIDが必ず異なる識別子になるようにする。
        const blockId = Array.from(block.id, (c) =>
            /[a-zA-Z0-9]/.test(c) ? c : `_${c.charCodeAt(0).toString(16).padStart(2, '0')}`,
        ).join('');
        const bufName = `_stddevBuf_${blockId}`;
        const countName = `_stddevCount_${blockId}`;
        const idxName = `_stddevIdx_${blockId}`;

        registerHelperFunction('math_stddev_calc', STDDEV_CALC_HELPER_CODE);
        registerHelperFunction(`math_stddev_state_${blockId}`, stddevStateCode(bufName, countName, idxName, n));

        return expr(`_sbeGetStddev((float)(${value}), ${bufName}, &${countName}, &${idxName}, ${n})`);
    };
}
